import classes from './Logistics.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
  from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import {Link} from "react-scroll";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Helmet} from "react-helmet-async";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import { useTranslation } from 'react-i18next';

const Logistics = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();
          
  const title = t('logistics.title')
  const description = t('logistics.text', {returnObjects: true})

  const blackBlocks = t('logistics.blackBlocks', {returnObjects: true})

  const challengesBlocks = t('logistics.challengesBlocks', {returnObjects: true})

  const solutionsBlocks= t('logistics.solutionsBlocks', {returnObjects: true})

  const benefitBlocks= t('logistics.benefitBlocks', {returnObjects: true})

  const stories = t('logistics.stories', {returnObjects: true})


  return (
      <>
        <Helmet>
          <title>Logistics & Supply Chain Solutions | Streamline Your Operations – Goteco</title>
          <meta
              name="description"
              content="Optimize logistics and supply chain operations with custom software solutions. Manage inventory, transportation, warehouses, and deliveries with Goteco logistics systems."
          />
          <link rel="canonical" href="https://go-te.co/industries/logistics-and-supply-chains"/>

        </Helmet>

        <main>
          <Heading title={title} description={description} maxWidth={680}/>

          <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
            <div>
              <h3>{t('logistics.blackBlocksTitle')}</h3>
              <p>{t('logistics.blackBlocksText')}</p>
            </div>
            <div className={classes.blocks}>
              {blackBlocks.map(({text, icon, title}) => (
                  <BlackCardWithIcon key={icon} iconName={icon} text={text} title={title}/>
              ))}
            </div>
          </section>

          <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
            <div>
              <h2>{t('logistics.challengesBlocksTitle')}</h2>
            </div>
            <div>
              {challengesBlocks.map(({icon, text, title}) => (
                  <GrayCardBlueIcon
                      iconName={icon}
                      title={title}
                      text={text}
                      key={title}
                  />
              ))}
            </div>
          </section>

          <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
            <div>
              <h2>{t('logistics.solutionsBlocksTitle')}</h2>
            </div>
            <div>
              {solutionsBlocks.map(({image, title, text}) => (
                  <div className={classes.block} key={title}>
                    <img alt={title} src={require(`./media/${image}`)}/>
                    <div className={classes.content}>
                      <h5>{title}</h5>
                      <p>{text}</p>
                    </div>
                  </div>
              ))}
            </div>
          </section>

          <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
            <div>
              <h2>{t('logistics.benefitBlocksTitle')}</h2>
            </div>
            <div>
              {benefitBlocks.map(({title, text}) => (
                  <BlueGradientBlock title={title} text={text} key={title}/>
              ))}
            </div>
          </section>

          <section className={"section--dark-gray " + classes['stories']}>
            <h2>{t('logistics.storiesTitle')}</h2>
            <div className={classes.blocks}>
              {stories.map(({title, text}) => (
                  <GrayCardWithVerticalDivider title={title} text={text} key={title}/>
              ))}
            </div>
          </section>

          <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
            <div className={classes.content}>
              <div className={classes['text-block']}>
                <h2>{t('logistics.useCase')}</h2>
                <div className={classes.text}>
                  <img src={eRoadImg} alt="Logistics use case"/>
                  <p>{t('logistics.useCaseSubtitle')}</p>
                </div>
              </div>
              <div className={classes.actions}>
                <span>{t('logistics.useCaseText')}</span>
                <Link className={classes.link} smooth={true} to={'contact'}>
                  {t('logistics.useCaseButton')}
                </Link>
              </div>
            </div>
            <img className={classes.img} src={eRoadImg} alt="Logistics system"/>
          </section>

          <section className="section--white" id="nav-dark">
            <FormCard
                title={t('logistics.formCard.title')}
                message={t('logistics.formCard.message')}
                buttonText={t('logistics.formCard.buttonText')}
                labels={t('logistics.formCard.labels', {returnObjects: true})}
                top={3}
                id='contact'
            />
          </section>
        </main>
      </>
  );
};

export default Logistics;